import type { CharacterConfig } from '../types/content';

export const characters: CharacterConfig[] = [
  {
    id: 'rebel',
    name: 'Rebel Roach',
    shortName: 'REBEL',
    description: 'Has two jumps and seventeen opinions ready before breakfast.',
    accent: 0xff5a54,
    passiveId: 'double-jump',
    passiveLabel: 'Double jump + sharp air control',
    activeAbilityId: 'slogan-surge',
    abilityLabel: 'Slogan Surge',
    tradeOff: 'Wanted rises faster during the surge.',
    cooldownMs: 12_000,
    movement: { speed: 270, acceleration: 1500, jumpVelocity: -500, airControl: 0.92, maxJumps: 2, crawlSpeed: 135 },
    modifiers: { wantedGain: 1.25, pushback: 1, scoreStreak: 1 },
  },
  {
    id: 'jugaadu',
    name: 'Jugaadu Roach',
    shortName: 'JUGAADU',
    description: 'If it has tape, wire, or questionable warranty status, it can be fixed.',
    accent: 0xa9ff3f,
    passiveId: 'narrow-crawl',
    passiveLabel: 'Fast crawl + enemy stun',
    activeAbilityId: 'quick-fix',
    abilityLabel: 'Jugaad Jam',
    tradeOff: 'Slower top speed and a shorter jump.',
    cooldownMs: 12_000,
    movement: { speed: 240, acceleration: 1450, jumpVelocity: -460, airControl: 0.86, maxJumps: 1, crawlSpeed: 170 },
    modifiers: { wantedGain: 1, pushback: 1, scoreStreak: 1 },
  },
  {
    id: 'gen-z',
    name: 'Gen Z Roach',
    shortName: 'GEN Z',
    description: 'Low battery, high engagement, zero plans to log off.',
    accent: 0x5c70ff,
    passiveId: 'trend-streak',
    passiveLabel: 'No-hit collectible multiplier',
    activeAbilityId: 'morph-shift',
    abilityLabel: 'Role Swap',
    tradeOff: 'Transforms are short and break when hit.',
    cooldownMs: 2_000,
    movement: { speed: 280, acceleration: 1550, jumpVelocity: -490, airControl: 0.9, maxJumps: 1, crawlSpeed: 145 },
    modifiers: { wantedGain: 1, pushback: 1.25, scoreStreak: 1.5 },
  },
];

export function getCharacter(id: CharacterConfig['id']): CharacterConfig {
  return characters.find((character) => character.id === id) ?? characters[0];
}
